import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import FaixaFarolLookup from 'src/lookups/faixa-farol';
import DatePicker from 'src/componentes/date-picker';
import Input from 'src/componentes/input';
import { TIPO_ITENS } from 'src/utils/constants';

const Geral = ({ props }) => {
  const { model, disabled, podeEditar, tipoItem, ehCampoBloqueado } = props;
  const intl = useIntl();

  const modelIdIntegracao = model.getModel('idIntegracao');
  const modelFaixaFarol = model.getModel('faixaFarol');
  const modelDataInicio = model.getModel('dataInicio');
  const modelDataTermino = model.getModel('dataTermino');

  return (
    <>
      <Row>
        <Col md={6}>
          <Input
            model={{
              label: intl.formatMessage({ id: 'idIntegracao' }),
              value: modelIdIntegracao.value,
              requestChange: modelIdIntegracao.requestChange,
              errors: modelIdIntegracao.errors,
            }}
            required
            disabled={disabled || !podeEditar}
          />
        </Col>
        <Col md={6}>
          <FaixaFarolLookup
            data={
              tipoItem == TIPO_ITENS.INDICADOR_RISCO
                ? {
                    exibirApenasValorAbsoluto: true,
                    //BELT-2909: Quando for "Indicador de Risco", olhar apenas para Valor Absoluto.
                    //           Pode aparecer Indicadores de outros Módulos, contanto que seja Valor Absoluto.
                  }
                : {}
            }
            model={{
              label: intl.formatMessage({ id: 'faixaDeFarol' }),
              value: modelFaixaFarol.value,
              requestChange: modelFaixaFarol.requestChange,
              errors: modelFaixaFarol.errors,
            }}
            required
            disabled={disabled || !podeEditar || ehCampoBloqueado('faixa')}
            propsEdit={{ exibirApenasValorAbsoluto: true }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <DatePicker
            month
            model={{
              label: intl.formatMessage({ id: 'dataInicio' }),
              value: modelDataInicio.value,
              requestChange: modelDataInicio.requestChange,
              errors: modelDataInicio.errors,
            }}
            disabled={disabled || !podeEditar}
            required
          />
        </Col>
        <Col md={3}>
          <DatePicker
            month
            model={{
              label: intl.formatMessage({ id: 'dataTermino' }),
              value: modelDataTermino.value,
              requestChange: modelDataTermino.requestChange,
              errors: modelDataTermino.errors,
            }}
            disabled={disabled || !podeEditar}
          />
        </Col>
      </Row>
    </>
  );
};

export default Geral;
